export interface GetGsmStockListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetGsmStockListPagingAndFilterResponseData
}

export interface GetGsmStockListPagingAndFilterResponseData {
    items: GetGsmStockListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetGsmStockListPagingAndFilterResponseItem {
    gsmStockId: string
    refNo: string
    gsmStatusId: string
    phone: string
    iccId: string
    gsmOperatorId: string
    gsmCardTypeId: string
    gsmCardStatusId: string
    deliveryDate: string
    agreementStartDate: string
    agreementEndDate: string
    gsmOperatorName: string
    gsmCardTypeName: string
    gsmCardStatusName: string
    gsmStatusName: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetGsmStockListPagingAndFilterResponseData: GetGsmStockListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}